import React from 'react';
import { FadeIn } from '../components/ui/FadeIn';
import { Button } from '../components/ui/Button';
import { SectionHeading } from '../components/ui/SectionHeading';
export function BeautyServices() {
  const services = [{
    name: 'Brow Design',
    price: '$35',
    text: 'Softly sculpted, beautifully defined brows.',
    image: 'https://cdn.magicpatterns.com/uploads/7BRtCTZawPqu137zyFeP9F/1a.png'
  }, {
    name: 'Korean Lash Lift',
    price: '$85',
    text: 'A natural lash enhancement with an elegant, lifted finish.',
    image: 'https://cdn.magicpatterns.com/uploads/g2SZu4zULHP7j5cejPyA8M/2a.png'
  }, {
    name: 'Custom Glow Facial',
    price: '$95',
    text: 'Personalized skincare for radiant, refreshed skin.',
    image: 'https://cdn.magicpatterns.com/uploads/meQt8R66EYBFRXvSPYcixK/3a.png'
  }, {
    name: 'Social Makeup',
    price: '$165',
    text: 'Refined makeup artistry for events, celebrations, and special occasions.',
    image: 'https://cdn.magicpatterns.com/uploads/vDgLA7dZBw2Q4Zmzg3Wqp1/4a.png'
  }, {
    name: 'PMU Brow',
    price: '$299',
    text: 'A semi-permanent brow enhancement designed for soft definition and lasting polish.',
    image: 'https://cdn.magicpatterns.com/uploads/vNgoS9VzAiUvLu7YJu68rz/5a.png'
  }];
  return <div className="bg-ivory" data-id="element-106">
      {/* Hero Section */}
      <section className="relative h-[70vh] min-h-[500px] flex items-center justify-center overflow-hidden" data-id="element-107">
        <div className="absolute inset-0 z-0" data-id="element-108">
          <img src="https://cdn.magicpatterns.com/uploads/msbtzWdaNMoUstc3opnQMy/7a.png" alt="Soft glowing beauty makeup portrait with defined brows and luminous eyes" className="w-full h-full object-cover object-center" data-id="element-109" />
          <div className="absolute inset-0 bg-espresso/40 mix-blend-multiply" data-id="element-110" />
        </div>

        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-20" data-id="element-111">
          <FadeIn delay={0.2} data-id="element-112">
            <h1 className="text-5xl md:text-7xl text-ivory mb-6 text-balance" data-id="element-113">
              Signature Beauty Services
            </h1>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-114">
            <p className="text-lg md:text-xl text-cream font-light text-balance" data-id="element-115">
              Refined on-site beauty for every moment.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Intro Section */}
      <section className="py-24 px-6" data-id="element-116">
        <div className="max-w-3xl mx-auto text-center" data-id="element-117">
          <FadeIn data-id="element-118">
            <p className="text-xl text-taupe font-light leading-relaxed" data-id="element-119">
              A curated edit of beauty services designed for women who value
              polished results, elevated care, and the ease of luxury brought
              directly to them. Available on-site in Charlotte, NC.
            </p>
          </FadeIn>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 px-6 bg-cream" data-id="element-120">
        <div className="max-w-5xl mx-auto space-y-16" data-id="element-121">
          {services.map((service, i) => <FadeIn key={i} direction={i % 2 === 0 ? 'right' : 'left'} className={`flex flex-col ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} gap-8 md:gap-16 items-center bg-white p-6 md:p-0 border border-champagne/30 md:border-none`} data-id="element-122">
              <div className="w-full md:w-1/2 aspect-[4/3] overflow-hidden" data-id="element-123">
                <img src={service.image} alt={service.name} className="w-full h-full object-cover" data-id="element-124" />
              </div>
              <div className="w-full md:w-1/2 flex flex-col justify-center text-center md:text-left md:px-8" data-id="element-125">
                <h3 className="text-3xl md:text-4xl text-espresso mb-2" data-id="element-126">
                  {service.name}
                </h3>
                <p className="text-lg text-gold mb-6" data-id="element-127">{service.price}</p>
                <p className="text-taupe font-light text-lg leading-relaxed mb-8" data-id="element-128">
                  {service.text}
                </p>
                <div className="w-12 h-[1px] bg-champagne/50 mx-auto md:mx-0" data-id="element-129" />
              </div>
            </FadeIn>)}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-32 px-6 text-center" data-id="element-130">
        <FadeIn data-id="element-131">
          <h2 className="text-4xl md:text-5xl font-serif text-espresso mb-6" data-id="element-132">
            Book Your Beauty Appointment
          </h2>
          <p className="text-taupe text-lg mb-10" data-id="element-133">
            Luxury beauty, delivered on-site.
          </p>
          <Button href="/contact" variant="primary" data-id="element-134">
            Book Now
          </Button>
        </FadeIn>
      </section>
    </div>;
}